export default __webpack_public_path__ + "static/media/o_wdt_c_1.a4309e99.mp3";